/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useCallback } from 'react';
import { FileSearchOutlined } from '@ant-design/icons';
import { State, UrlBuilder } from '../tools';
import DocumentationAPI from '../controls/react/form/documentationApi';
import Api from '../tools/api';
import { translator } from 'core/localization/localization';
import contextualHelpMap, { openHelpWindow } from './helpMapping';
import { ApplicationState } from 'framework/applicationState';

const b = require('b_').with('page-help-button');

const i = translator({
	'Click to view online documentation.': {
		no: 'Klikk for å se online dokumentasjon.',
	},
});

export const PageHelpButton = ({ currentKey }: { currentKey?: string }) => {
	const onClick = useCallback(async () => {
		// to receive origin and version
		const result = (await Api.fetch(DocumentationAPI.getActionTriggerDocumentationUrl())) as {
			success: boolean;
			data: string;
		};
		if (result.success) {
			const url = new URL(result.data);
			const urlBuilder = new UrlBuilder(url.origin).addPath(url.pathname.split('/').slice(1, 3).join('/'));

			const key = (currentKey ??
				(ApplicationState.currentHelpKey ||
					(State.mainApp._runtime.routeId ?? State.mainApp._runtime.moduleDescription?.routeId ?? ''))) as string;
			let path = contextualHelpMap.get(key) ?? '';
			if (path) {
				if (key == 'monitors_by_type') {
					path = contextualHelpMap.get(`monitor_${State.mainApp._runtime.configuration.monitorType}`) ?? '';
				}
				urlBuilder.addPath(path);
			}

			openHelpWindow(urlBuilder.build());
		}
	}, []);
	return (
		<>
			<FileSearchOutlined className={b()} onClick={onClick} title={i('Click to view online documentation.')} />
		</>
	);
};
